import {
  cva
} from "../../../chunk-6A7LB5UJ.mjs";
import "../../../chunk-QJVDQ4DQ.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/Progress/Progress.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var progressVariants = cva("buyscout-progress", {
  variants: {
    variant: {
      bar: null,
      segmented: "buyscout-progress--variant-segmented"
    },
    color: {
      primary: "buyscout-progress--color-primary",
      ink: "buyscout-progress--color-ink",
      error: "buyscout-progress--color-error"
    },
    size: {
      sm: "buyscout-progress--size-sm",
      md: "buyscout-progress--size-md",
      lg: "buyscout-progress--size-lg"
    }
  },
  defaultVariants: {
    variant: "bar",
    color: "primary",
    size: "md"
  }
});
function Progress({
  ref,
  ...props
}) {
  const { value = 0, max = 100, variant, color, size, meter = false, indeterminate: indeterminateProp = false, threshold, pending = false, className, ...rest } = props;
  const segmented = variant === "segmented";
  const indeterminate = indeterminateProp && !meter && !pending && !segmented;
  const safeMax = max > 0 ? segmented ? Math.max(1, Math.round(max)) : max : 0;
  const clamped = Math.min(Math.max(value, 0), safeMax);
  const pct = safeMax > 0 ? clamped / safeMax * 100 : 0;
  const thresholdPct = meter && !segmented && threshold !== void 0 && safeMax > 0 && threshold > 0 && threshold < safeMax ? threshold / safeMax * 100 : null;
  const classes = progressVariants({
    variant,
    color,
    size,
    className: [indeterminate && "buyscout-progress--indeterminate", meter && "buyscout-progress--meter", className].filter(Boolean).join(" ") || void 0
  });
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref,
      className: classes,
      role: meter && !pending ? "meter" : "progressbar",
      "aria-valuenow": indeterminate || pending ? void 0 : clamped,
      "aria-valuemin": 0,
      "aria-valuemax": indeterminate ? void 0 : safeMax,
      "aria-busy": pending || void 0,
      "data-empty": !indeterminate && !pending && clamped === 0 ? "" : void 0,
      ...rest,
      children: [
        segmented ? Array.from({ length: safeMax }, (_, index) => /* @__PURE__ */ jsx("span", { className: "buyscout-progress__segment", "data-filled": !pending && index < clamped ? "" : void 0 }, index)) : pending ? null : /* @__PURE__ */ jsx(
          "div",
          {
            className: "buyscout-progress__fill",
            style: indeterminate ? void 0 : { width: `${pct}%` }
          }
        ),
        thresholdPct !== null && /* @__PURE__ */ jsx("span", { className: "buyscout-progress__threshold", style: { insetInlineStart: `${thresholdPct}%` }, "aria-hidden": true })
      ]
    }
  );
}
Progress.displayName = "Progress";
export {
  Progress
};
//# sourceMappingURL=Progress.mjs.map